import { forwardRef } from "react";
import { Input } from "./ui/input";

/**
 * Free-text input with native HTML5 datalist autocomplete.
 * Works on mobile and desktop, feels like a real online booking form.
 */
export const AutocompleteInput = forwardRef(function AutocompleteInput(
  { id, options = [], value, onChange, placeholder, className = "", testId, ...rest },
  ref,
) {
  const listId = `${id}-list`;
  return (
    <>
      <Input
        ref={ref}
        id={id}
        data-testid={testId}
        list={listId}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        autoComplete="off"
        className={className}
        {...rest}
      />
      <datalist id={listId}>
        {options.map((o) => (
          <option key={o} value={o} />
        ))}
      </datalist>
    </>
  );
});
